import { Component, Fragment } from "react";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import GoogleMap from "../component/sidebar/googlemap";
import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const subTitle = "Partner with us";
const title = "We're Always Eager To Hear From You!";
const conSubTitle = "Partner With us";
const conTitle = "Fill The Form Below So We Can Get To Know You And Your Needs Better.";
const btnText = "Submit Now";


const contactList = [
    {
        imgUrl: 'assets/images/icon/01.png',
        imgAlt: 'contact icon',
        title: 'Office Address',
        desc: '1201 park street, Fifth Avenue',
    },
    {
        imgUrl: 'assets/images/icon/02.png',
        imgAlt: 'contact icon',
        title: 'Phone number',
        desc: '+22698 745 632,02 982 745',
    },
    {
        imgUrl: 'assets/images/icon/03.png',
        imgAlt: 'contact icon',
        title: 'Send email',
        desc: 'adminedukon@gmil.com',
    },
    {
        imgUrl: 'assets/images/icon/04.png',
        imgAlt: 'contact icon',
        title: 'Our website',
        desc: 'www.edukon.com',
    },
]


const ContactPage = () => {
    const [captchaValue, setCaptchaValue] = useState(null);

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };
    return (
        <Fragment>
            <Header />
            <PageHeader title={'Partner with us'} curPage={'Partner'} />
            {/* <div className="map-address-section padding-tb section-bg">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="subtitle">{subTitle}</span>
                        <h2 className="title">{title}</h2>
                    </div>
                    <div className="section-wrapper">
                        <div className="row flex-row-reverse">
                            <div className="col-xl-4 col-lg-5 col-12">
                                <div className="contact-wrapper">
                                    {contactList.map((val, i) => (
                                        <div className="contact-item" key={i}>
                                            <div className="contact-thumb">
                                                <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                                            </div>
                                            <div className="contact-content">
                                                <h6 className="title">{val.title}</h6>
                                                <p>{val.desc}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-xl-8 col-lg-7 col-12">
                                <GoogleMap />
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="">
                <div className="container mt-8">
                    <div className="section-header text-center">
                        <span className="subtitle">{conSubTitle}</span>
                        <h4 className="title">{conTitle}</h4>
                    </div>
                    <div className=" container row  mt-4 mb-4">

                        <div className="section-wrapper col-md-6 col-12 md:border-r border-gray-200 mt-4">
                            <span className="text-md font-semibold">Personal Details</span>
                            <form className="contact-form">
                                <div className="form-group">
                                    <input
                                        className=""
                                        type="text"
                                        name="name"
                                        placeholder="Your Name *"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="email"
                                        placeholder="Your Email *"
                                        required

                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="email"
                                        placeholder="Confirm Email *"
                                        required

                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="number"
                                        placeholder="Mobile Number"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="number"
                                        placeholder="Whatsapp Number *"
                                        required

                                    />
                                </div>
                                {/* <div className="form-group">
                              <input
                                  type="text"
                                  name="subject"
                                  placeholder="Your Subject *"
                              />
                          </div> */}
                                {/* <div className="form-group w-100">
                              <textarea 
                                  rows="8" 
                                  type="text"
                                  placeholder="Your Message"
                              ></textarea>
                          </div> */}
                                {/* <div className="form-group w-100 text-center">
                              <button className="lab-btn"><span>{btnText}</span></button>
                          </div> */}
                            </form>
                        </div>
                        <div className="section-wrapper col-md-6 col-12 mt-4  ">
                            <span className="text-md font-semibold">Business Owner Details</span>
                            <form className="contact-form">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Company Name *"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="email"
                                        placeholder="Company Email *"
                                        required

                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="number"
                                        placeholder="Company phone/whatsapp Number *"
                                        required

                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="website"
                                        placeholder=" Website"
                                        required

                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="website"
                                        placeholder=" Address *"
                                        required

                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="website"
                                        placeholder=" City *"
                                        required

                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="website"
                                        placeholder=" Country *"
                                        required

                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="website"
                                        placeholder=" state *"
                                        required

                                    />
                                </div>
                                {/* <div className="form-group w-100">
                              <textarea 
                                  rows="8" 
                                  type="text"
                                  placeholder="Your Message"
                              ></textarea>
                          </div> */}
                                {/* <div className="form-group w-100 text-center">
                              <button className="lab-btn"><span>{btnText}</span></button>
                          </div> */}
                            </form>
                        </div>
                        <div className="section-wrapper col-md-6 col-12 mt-4 mb-4">
                            <span className="text-md font-semibold">Financial Details</span>

                            <form className="contact-form">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Email ID for Commission verification *"
                                    />
                                </div>

                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="number"
                                        placeholder="Whatsapp no for Commission verification *"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="website"
                                        placeholder=" Phone No for Commission verification* "
                                    />
                                </div>




                                {/* <div className="form-group w-100">
                              <textarea 
                                  rows="8" 
                                  type="text"
                                  placeholder="Your Message"
                              ></textarea>
                          </div> */}
                                {/* <div className="form-group w-100 text-center">
                              <button className="lab-btn"><span>{btnText}</span></button>
                          </div> */}
                            </form>
                        </div>
                        <div className="section-wrapper  flex justify-center items-center col-md-6 col-12 mt-4">
                            <div className="form-group">

                                <ReCAPTCHA
                                    sitekey="YOUR_RECAPTCHA_SITE_KEY" // Replace with your Google reCAPTCHA site key
                                    onChange={handleCaptchaChange}
                                />
                            </div>
                        </div>

                        <div className="form-group mt-4 w-100 text-center">
                                <button className="lab-btn"><span>{btnText}</span></button>
                            </div>
                    </div>
                </div>
            </div>
            <Footer />
        </Fragment>
    );
}



export default ContactPage;